import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import { telegramWebApp } from '@/main';
import {
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerFooter,
	Button,
	// CoinImage,
	DrawerTitle,
	DrawerDescription,
	Network,
	CoinImage,
} from '@/app/shared/components';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
// import { Network } from '@/app/shared/components';
import { setCounter } from '@/core/redux/slices';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

interface LastTimeIncrementedProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LastTimeIncremented: React.FC<LastTimeIncrementedProps> = ({
	isOpen,
	onClose,
}: LastTimeIncrementedProps) => {
	/*********************
	// #region Hooks
	**********************/
	const dispatch = useCustomDispatch();
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { networkSelected } = useCustomSelector((state) => state.network);
	// const { last_time_incremented, counter, friends_reward } =
	const { last_time_incremented, counter, friends_reward } =
		useCustomSelector((state) => state.counter);

	/*********************
	// #region Template
	**********************/
	return (
		<Drawer open={isOpen} onOpenChange={onClose}>
			<DrawerContent>
				<div className="mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" />
				<DrawerTitle>
					<VisuallyHidden>
						{t('dashboard.lastTimeIncremented.description')}
					</VisuallyHidden>
				</DrawerTitle>

				<DrawerDescription>
					<VisuallyHidden>
						{t('dashboard.lastTimeIncremented.description')}
					</VisuallyHidden>
				</DrawerDescription>
				<div className="mx-auto max-w-sm py-6">
					<div className="text-center">
						<div className="inline-flex items-center gap-2 mb-8 rounded-full bg-vottun-950/40 px-6 py-3 mx-auto">
							<Network width="30px" />
							<p className="font-bold">{networkSelected.name}</p>
						</div>
					</div>

					<div className="text-center mx-6">
						<p className="px-5 text-md font-bold text-center">
							{t('dashboard.lastTimeIncremented.description')}
						</p>

						<div
							className={`flex flex-row gap-2 items-center justify-center`}
						>
							<CoinImage
								classes="flex-1 h-[30px] max-w-[30px]"
								width={'30px'}
							/>

							<p className="text-4xl font-bold text-center text-shadow">
								{numify(
									friends_reward > 0
										? last_time_incremented - friends_reward
										: last_time_incremented
								)}
							</p>
						</div>

						{friends_reward > 0 && (
							<>
								<div className="w-[75%] mx-auto bg-customer-100 h-px my-4 opacity-40"></div>

								<p className="px-5 text-md font-bold text-center">
									{t('dashboard.friendsReward.description')}
								</p>

								<div
									className={`flex flex-row gap-2 items-center justify-center`}
								>
									<CoinImage
										classes="flex-1 h-[30px] max-w-[30px]"
										width={'30px'}
									/>

									<p className="text-4xl font-bold text-center text-shadow">
										{numify(friends_reward)}
									</p>
								</div>
							</>
						)}
					</div>
				</div>
				<DrawerFooter>
					<DrawerClose asChild>
						<Button
							variant="primary"
							onClick={() => {
								telegramWebApp.HapticFeedback.impactOccurred(
									'heavy'
								);
								dispatch(
									setCounter(counter + last_time_incremented)
								);
								onClose(false);
							}}
						>
							{t('general.thanks')}
						</Button>
					</DrawerClose>
				</DrawerFooter>

				{/* <div className="mx-auto w-full max-w-sm">
					<div className="p-4 pb-0 mx-auto flex flex-col items-center">
						<div className="flex items-center gap-2 mb-8 rounded-full bg-vottun-950/40 px-6 py-3">
							<Network width="30px" />
							<p className="font-bold">{networkSelected.name}</p>
						</div>
						<div className="flex flex-col space-y-3">
							<p className="px-5 text-lg font-bold text-center justify-center">
								{t('dashboard.lastTimeIncremented.description')}
							</p>
							<div
								className={`flex flex-row gap-2 items-center justify-center`}
							>
								<CoinImage
									classes="flex-1 h-[30px] max-w-[30px]"
									width={'30px'}
								/>

								<p className="text-4xl font-bold text-center text-shadow">
									{numify(
										friends_reward > 0
											? last_time_incremented -
													friends_reward
											: last_time_incremented
									)}
								</p>
							</div>
						</div>

						{friends_reward > 0 && (
							<>
								<div className="w-[75%] bg-customer-100 mx-2 h-px my-4 opacity-40"></div>
								<div
									className={`flex flex-col space-y-3 justify-center`}
								>
									<p className="px-5 text-lg font-bold text-center justify-center">
										{t(
											'dashboard.friendsReward.description'
										)}
									</p>
									<div
										className={`flex flex-row items-center justify-center`}
									>
										<CoinImage
											classes="flex-1 h-[30px] max-w-[30px]"
											width={'30px'}
										/>
										<p className="text-4xl font-bold text-center text-shadow">
											{numify(friends_reward)}
										</p>
									</div>
								</div>
							</>
						)}
					</div>
					<DrawerFooter>
						<DrawerClose asChild>
							<Button
								variant="primary"
								onClick={() => {
									telegramWebApp.HapticFeedback.impactOccurred(
										'heavy'
									);
									dispatch(
										setCounter(
											counter + last_time_incremented
										)
									);
									onClose(false);
								}}
							>
								{t('general.thanks')}
							</Button>
						</DrawerClose>
					</DrawerFooter>
				</div> */}
			</DrawerContent>
		</Drawer>
	);
};
